import { render, staticRenderFns } from "./Prefixes.vue?vue&type=template&id=9c445892&scoped=true&"
import script from "./Prefixes.vue?vue&type=script&lang=js&"
export * from "./Prefixes.vue?vue&type=script&lang=js&"
import style0 from "./Prefixes.vue?vue&type=style&index=0&id=9c445892&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c445892",
  null
  
)

export default component.exports